import React from "react";
import { useTranslation } from "react-i18next";
import "../App.css";
import "../utils/styles/PageAnimations.css";

function HelpPage() {
  const { t } = useTranslation();

  return (
    <div
      className="help-page page-animated"
      style={{
        padding: "5rem 2rem",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      <h1
        className="animate-up delay-1"
        style={{
          textAlign: "center",
          marginBottom: "4rem",
          fontSize: "3rem",
          color: "#1d2b45",
        }}
      >
        Hilfe & Anleitung
      </h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: "4rem",
          alignItems: "center",
        }}
      >
        <div
          className="animate-left delay-2"
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src="/images/screens/help.png"
            alt="Help"
            className="hover-image"
            style={{
              width: "100%",
              maxWidth: "500px",
              borderRadius: "24px",
              boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
              background: "#fff",
              padding: "1rem",
            }}
          />
        </div>

        <div
          className="animate-right delay-3 hover-card"
          style={{
            background: "rgba(255,255,255,0.92)",
            borderRadius: "24px",
            padding: "2.5rem",
            boxShadow: "0 10px 30px rgba(31,152,244,0.08)",
            border: "1px solid rgba(3,122,246,0.08)",
            backdropFilter: "blur(10px)",
          }}
        >
          <h2
            style={{
              marginBottom: "1.5rem",
              fontSize: "2rem",
              color: "#1d2b45",
            }}
          >
            Schnell & einfach erklärt
          </h2>

          <p
            style={{
              marginBottom: "1.5rem",
              lineHeight: "1.9",
              fontSize: "1.08rem",
              color: "#42526b",
            }}
          >
            Hier findest du hilfreiche Informationen und Schritt-für-Schritt
            Anleitungen zur Nutzung von Onenizer.
          </p>

          <div
            style={{
              display: "grid",
              gap: "1rem",
            }}
          >
            <div
              className="hover-card"
              style={{
                padding: "1rem 1.2rem",
                borderRadius: "16px",
                background: "#f7fbff",
                border: "1px solid rgba(3,122,246,0.08)",
              }}
            >
              <strong style={{ color: "#037af6" }}>
                ✅ Aufgaben verwalten
              </strong>

              <p style={{ marginTop: "0.4rem", color: "#42526b" }}>
                Lerne wie du To-Do Listen und Notizen effizient organisierst.
              </p>
            </div>

            <div
              className="hover-card"
              style={{
                padding: "1rem 1.2rem",
                borderRadius: "16px",
                background: "#f7fbff",
                border: "1px solid rgba(3,122,246,0.08)",
              }}
            >
              <strong style={{ color: "#037af6" }}>
                👥 Mit Freunden teilen
              </strong>

              <p style={{ marginTop: "0.4rem", color: "#42526b" }}>
                Teile Listen, Termine und Planungen gemeinsam mit Familie oder
                Freunden.
              </p>
            </div>

            <div
              className="hover-card"
              style={{
                padding: "1rem 1.2rem",
                borderRadius: "16px",
                background: "#f7fbff",
                border: "1px solid rgba(3,122,246,0.08)",
              }}
            >
              <strong style={{ color: "#037af6" }}>
                📱 App optimal nutzen
              </strong>

              <p style={{ marginTop: "0.4rem", color: "#42526b" }}>
                Entdecke Tipps & Tricks für die beste Nutzung von Onenizer.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpPage;
